<div class="container mb-4" *ngIf="registers">
    <h3 class="heading">{{ "GENERAL.NEXT-GAMES" | translate }}</h3>
    <div class="row">
        <div class="col-md-6 match-col match-vip" *ngIf="registers?.vip">
            <!-- <p class="match-col-title mb-2">VIP</p> -->
            <nb-card accent="primary" routerLink="/tournaments-central" class="cursor-pointer">
                <nb-card-body>
                    <div class="d-flex justify-content-center my-2">
                        <nb-icon icon="star" status="primary"></nb-icon>
                        <nb-icon icon="star" status="primary"></nb-icon>
                        <nb-icon icon="star" status="primary"></nb-icon>
                    </div>
                    <div class="match-participants">
                        <div class="d-flex align-items-center justify-content-start">
                            <div class="match-participant" *ngFor="let participant of registers.vip.participantes['1']">
                                <div class="match-participant-avatar">
                                    <img [src]="participant.url_avatar" [alt]="participant.nome" />
                                </div>
                                <p class="match-participant-name">{{ participant.nome }}</p>
                            </div>
                        </div>
                        <div class="match-participants-vs">
                            <span>- vs -</span>
                        </div>
                        <div class="d-flex align-items-center justify-content-end">
                            <div class="match-participant" *ngFor="let participant of registers.vip.participantes['2']">
                                <div class="match-participant-avatar">
                                    <img [src]="participant.url_avatar" [alt]="participant.nome" />
                                </div>
                                <p class="match-participant-name">{{ participant.nome }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap justify-content-center mt-1 match-h2h" *ngIf="registers?.vip.h2h">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <span class="caption">{{ registers?.vip.h2h.perform.lado_1 }}%</span>
                            <p class="label m-0">{{ "GAME.PROBABILITY-VICTORY" | translate }}</p>
                            <span class="caption">{{ registers?.vip.h2h.perform.lado_2 }}%</span>
                        </div>
                        <nb-progress-bar
                            *ngIf="registers?.vip.h2h"
                            status="primary"
                            size="tiny"
                            [value]="registers?.vip.h2h.perform.lado_1"
                            class="w-100"
                        ></nb-progress-bar>
                    </div>
                </nb-card-body>
                <nb-card-footer>
                    <div class="match-info">
                        <span class="match-category">{{ registers.vip.nome_categoria }}</span>
                        <span>{{ registers.vip.dt_jogo }} {{ registers.vip.hr_jogo }}</span>
                    </div>
                </nb-card-footer>
            </nb-card>
        </div>
        <div class="col-md-6 match-col" *ngIf="list.length">
            <!-- <p class="match-col-title mb-2">Jogos Programados</p> -->
            <ngb-carousel [showNavigationIndicators]="false" [showNavigationArrows]="true" [interval]="10000">
                <ng-template ngbSlide *ngFor="let match of list">
                    <nb-card routerLink="/tournaments-central" class="cursor-pointer">
                        <nb-card-body>
                            <div class="match-participants">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div class="match-participant" *ngFor="let participant of match.participantes['1']">
                                        <div class="match-participant-avatar">
                                            <img [src]="participant.url_avatar" [alt]="participant.nome" />
                                        </div>
                                        <p class="match-participant-name">{{ participant.nome }}</p>
                                    </div>
                                </div>
                                <div class="match-participants-vs">
                                    <span>- vs -</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-end">
                                    <div class="match-participant" *ngFor="let participant of match.participantes['2']">
                                        <div class="match-participant-avatar">
                                            <img [src]="participant.url_avatar" [alt]="participant.nome" />
                                        </div>
                                        <p class="match-participant-name">{{ participant.nome }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap justify-content-center mt-1 match-h2h" *ngIf="match.h2h">
                                <div class="d-flex justify-content-between align-items-center w-100">
                                    <span class="caption">{{ match.h2h.perform.lado_1 }}%</span>
                                    <p class="label m-0">{{ "GAME.PROBABILITY-VICTORY" | translate }}</p>
                                    <span class="caption">{{ match.h2h.perform.lado_2 }}%</span>
                                </div>
                                <nb-progress-bar
                                    *ngIf="match.h2h"
                                    status="primary"
                                    size="tiny"
                                    [value]="match.h2h.perform.lado_1"
                                    class="w-100"
                                ></nb-progress-bar>
                            </div>
                        </nb-card-body>
                        <nb-card-footer>
                            <div class="match-info">
                                <span class="match-category">{{ match.nome_categoria }}</span>
                                <span>{{ match.dt_jogo }} {{ match.hr_jogo }}</span>
                            </div>
                        </nb-card-footer>
                    </nb-card>
                </ng-template>
            </ngb-carousel>
        </div>
    </div>
</div>
